import React from 'react';

import classes from './PaginationButton.css';

import downIcon from '../../../../icons/downPage.svg';



const PaginationButton = (props) => {

    return (
        <div className={classes.PaginationButtonGroup}>
            <div className={classes.PaginationHelper}
                onClick={props.paginationClicked}>
                <p className={classes.ButtonText}>Show More</p>
                <img 
                    className={classes.Image}
                    src={downIcon}
                    alt="not found" />
            </div>
        </div>
    )

}


export default PaginationButton


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/PaginationButton/PaginationButton.js